import * as React from "react";
import * as ReactDOM from "react-dom";
import { Popup, PopupMessage } from "sb-resp-ui";
import { getPopupConfigs } from "../../helpers";
var PopUp = /** @class */ (function () {
    function PopUp(config, msgStackContainer, legacyCallback) {
        this.config = getPopupConfigs(this, config, legacyCallback);
        this.msgContainer = document.createElement("div");
        this.msgStackContainer = msgStackContainer || document.body;
    }
    PopUp.prototype.show = function () {
        this.msgStackContainer.appendChild(this.msgContainer);
        this.config.popupShowConfig.popupPortalEl = this.msgContainer;
        var msg = ReactDOM.render(React.createElement(Popup, {
            config: this.config.popupShowConfig
        }, React.createElement(PopupMessage, {
            config: this.config.popupMessageConfig
        })), this.msgContainer);
        return msg;
    };
    PopUp.prototype.hide = function () {
        ReactDOM.unmountComponentAtNode(this.msgContainer);
        return this;
    };
    return PopUp;
}());
export { PopUp };
//# sourceMappingURL=PopUp.js.map